<div class="single-ticket">
    <div class="single-ticket__content">
        <div class="border-line"></div>
        <div class="single-ticket__top-content">
            <div class="single-ticket-left-content">
                <div
                    class="single-ticket-left-content__items"
                    [ngClass]="{ 'transit-message': ticket.trip_messages?.length > 0 }">
                    <span class="title">{{ 'TICKET_SUMMARY_V2_ZONE' | translate }}</span>
                    <span class="description" *ngIf="ticket.area && ticket.area?.translations?.length > 0">{{
                        ticket.area | translateObjectField: 'descr' : locale
                    }}</span>
                    <span
                        class="description"
                        *ngIf="(!ticket.area || ticket.area.translations?.length === 0) && ticket.ticket_details">
                        {{ ticket.ticket_details.origin_stop_name }} &rsaquo;
                        {{ ticket.ticket_details.destination_stop_name }}

                        <ridango-trip-message
                            *ngIf="ticket.trip_messages?.length > 0"
                            [messages]="ticket.trip_messages"
                            [locale]="locale">
                        </ridango-trip-message>
                    </span>
                </div>

                <div class="single-ticket-left-content__items" *ngIf="!ticket.starting && !ticket.departure_time_min">
                    <span class="title">{{ 'TICKET_SUMMARY_V2_VALIDITY' | translate }}</span>
                    <span class="description">{{ 'TICKET_SUMMARY_V2_TRAVELLER_QR_TICKET' | translate }}</span>
                </div>

                <!--Please check this part I added the date class in 2 places-->
                <div class="single-ticket-left-content__items" *ngIf="ticket.departure_time_min">
                    <span class="title">{{ 'TICKET_DEPARTURE' | translate }}</span>
                    <span class="description"
                        >{{ ticket.departure_time_min | timeFromInt: 'HH:mm' }} &rsaquo;
                        {{ ticket.arrival_time_min | timeFromInt: 'HH:mm' }}
                        <!-- <span class="date" *ngIf="ticket.starting_formatted">
                            {{ticket.starting_formatted }}
                        </span> -->
                        <span class="date">
                            {{ ticket.starting | findDayName | translate }} {{ formatDate(ticket?.starting) }}
                        </span>
                    </span>
                </div>

                <div class="single-ticket-left-content__items" *ngIf="ticket.starting && ticket.ticket_details">
                    <span class="title">{{ 'TICKET_DEPARTURE' | translate }}</span>
                    <span class="description"
                        >{{ ticket.ticket_details.origin_stop_time_min | formatSeconds }} &rsaquo;
                        {{ ticket.ticket_details.destination_stop_time_min | formatSeconds }}

                        <!-- <span class="date" *ngIf="ticket.starting_formatted">
                            {{ticket.starting_formatted }}
                        </span> -->
                        <span class="date">
                            {{ ticket.starting | findDayName | translate }} {{ formatDate(ticket?.starting) }}
                        </span>
                    </span>
                </div>
                <!---->
            </div>

            <div class="single-ticket-right-content">
                <div class="single-ticket-left-content__items full-width">
                    <span class="title">{{ 'TICKET_SUMMARY_V2_PRICE' | translate }}</span>
                    <span class="description" *ngIf="!ticket.price && ticket.product_price_object?.price"
                        >{{ ticket.product_price_object.price | moneyFormat }}
                        {{ appStartupService.getCurrency() | translate }}</span
                    >
                    <span
                        class="description"
                        *ngIf="!ticket.price && !ticket.product_price_object && ticket.product?.price"
                        >{{ ticket.product.price | moneyFormat }}
                        {{ appStartupService.getCurrency() | translate }}</span
                    >
                    <span class="description" *ngIf="ticket.price"
                        >{{ ticket.price | moneyFormat }} {{ appStartupService.getCurrency() | translate }}</span
                    >
                    <span
                        class="description"
                        *ngIf="!ticket.price && !ticket.product_price_object && !ticket.product?.price"
                        >-</span
                    >
                </div>
            </div>
        </div>

        <div class="single-ticket-left-content remove-padding-margin-border">
            <div class="single-ticket-left-content__items">
                <span class="title">{{ 'TICKET_SUMMARY_V2_TICKET_TYPE' | translate }}</span>

                <!--Please check this part related to the first class tickets(Do we need to have the same for "ticket.product_object")-->
                <span class="secondary-description" *ngIf="ticket.product_object">{{
                    ticket.product_object | translateObjectField: 'name' : locale
                }}</span>
                <span class="secondary-description" *ngIf="!ticket.product_object && ticket.product">
                    <span class="class-seat">{{ ticket.product | translateObjectField: 'name' : locale }}</span>
                    <span class="train-name" *ngIf="ticket.multi_train && ticket.train_name">
                        {{ 'TRAIN' | translate | uppercase }} {{ ticket.train_name }}
                    </span>
                    <span class="seat-number" *ngIf="ticket.seatName || ticket.seat_name">
                        {{ ticket.seatName ? ticket.seatName : ticket.seat_name }}
                    </span>
                </span>
                <!---->
            </div>

            <div class="single-ticket-left-content__items">
                <span class="title">
                    <span class="inline-title" *ngIf="ticket.travellerCategory">{{
                        'TICKET_SUMMARY_V2_TRAVELLER' | translate
                    }}</span>
                    <span class="dash" *ngIf="ticket.travellerCategory">-</span>
                    <span class="inline-title" *ngIf="ticket.card_type && ticket.card_type !== 'Q'">{{
                        'TICKET_SUMMARY_V2_TRAVELLER_CARD' | translate
                    }}</span>
                    <span class="inline-title" *ngIf="ticket.card_type && ticket.card_type === 'Q'">{{
                        'TICKET_SUMMARY_V2_TRAVELLER_EMAIL' | translate
                    }}</span>
                    <span class="title" *ngIf="!ticket.travellerCategory && !ticket.card_type">{{
                        'TICKET_MEDIUM' | translate
                    }}</span>
                </span>
                <span class="inline-secondary-description" *ngIf="ticket.travellerCategory">{{
                    ticket.travellerCategory | translateObjectField: 'name' : locale
                }}</span>
                <span class="dash" *ngIf="ticket.travellerCategory">-</span>
                <span class="inline-secondary-description" *ngIf="getMedium()">{{ getMedium() }}</span>
                <span
                    class="inline-secondary-description"
                    class="main-color"
                    *ngIf="!ticket.travellerCategory && !getMedium()"
                    >{{ 'CHOOSE_MEDIUM_BELOW' | translate }}</span
                >
            </div>

            <div class="single-ticket-left-content__items" *ngIf="ticket.wifi_key">
                <span class="title">{{ 'TICKET_SUMMARY_V2_WIFI_PASSWORD' | translate }}</span>
                <span class="secondary-description">{{ ticket.wifi_key }}</span>
            </div>
        </div>

        <div class="single-ticket-right-content remove-padding-margin-border">
            <ridango-ticket-actions-dropdown
                *ngIf="!useInputActions && ticket.actions && ticket.actions.length !== 0"
                [actions]="ticket.actions"
                [type]="'REGULAR'"
                [locale]="locale"
                (actionClicked)="actionClicked($event, ticket)">
            </ridango-ticket-actions-dropdown>
            <ridango-ticket-actions-dropdown
                *ngIf="useInputActions"
                [actions]="actions"
                [type]="'REGULAR'"
                [locale]="locale"
                (actionClicked)="actionClicked($event, ticket)">
            </ridango-ticket-actions-dropdown>
        </div>
    </div>
</div>
